import { render } from "./SmartSliderLocator.vue?vue&type=template&id=4ae799d2"
import script from "./SmartSliderLocator.vue?vue&type=script&lang=js"
export * from "./SmartSliderLocator.vue?vue&type=script&lang=js"

import "./SmartSliderLocator.vue?vue&type=style&index=0&id=4ae799d2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__